var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSqueezeTrendsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.6436,
    cy: 16.5977,
    r: 16,
    fill: "#313131"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5774 12.3327C19.1115 12.3327 17.9233 13.5266 17.9233 14.9993C17.9233 16.4721 19.1115 17.666 20.5774 17.666C22.0432 17.666 23.2314 16.4721 23.2314 14.9993C23.2314 13.5266 22.0432 12.3327 20.5774 12.3327Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2739 10.3327C13.3578 10.3327 12.6151 11.0789 12.6151 11.9993C12.6151 12.9198 13.3578 13.666 14.2739 13.666C15.1901 13.666 15.9327 12.9198 15.9327 11.9993C15.9327 11.0789 15.1901 10.3327 14.2739 10.3327Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9421 15.666C11.7434 15.666 9.96094 17.4569 9.96094 19.666C9.96094 21.8752 11.7434 23.666 13.9421 23.666C16.1408 23.666 17.9232 21.8752 17.9232 19.666C17.9232 17.4569 16.1408 15.666 13.9421 15.666Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqueezeTrendsIcon);
export default __webpack_public_path__ + "static/media/squeeze_trends_icon.90b9bd27a312ef8df492347545325d9c.svg";
export { ForwardRef as ReactComponent };